'use client';

import { Box, Unstable_Grid2 as Grid, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import Section from '@/components/Section';
const text = {
  title: 'چطور ',
  highlight: '۵ سوت طلا',
  subtitle: ' بگیری؟',
  levels: 'مراحل ثبت‌نام',
  step1: {
    title: 'مرحله ۱: ثبت‌نام در زیما:',
    description: 'با وارد کردن کد ملی، حساب کاربری خود را ایجاد کنید.'
  },
  step2: {
    title: 'مرحله ۲: احراز هویت سریع:',
    description: 'شماره تلفن همراه خود را تأیید کنید.'
  },
  step3: {
    title: 'مرحله ۳: دریافت ۵ سوت طلا:',
    description: 'پس از تأیید، هدیه خود را در وال‌گلد دریافت کنید.'
  }
};
export const SignupLevels = () => {
  return <Section data-sentry-element="Section" data-sentry-component="SignupLevels" data-sentry-source-file="SignupLevels.tsx">
      <Grid container data-sentry-element="Grid" data-sentry-source-file="SignupLevels.tsx">
        <Grid xs={12} md={5} data-sentry-element="Grid" data-sentry-source-file="SignupLevels.tsx">
          <Stack alignItems='center' justifyContent='center' sx={{
          position: 'relative'
        }} height='100%' data-sentry-element="Stack" data-sentry-source-file="SignupLevels.tsx">
            <Image src='/images/home/path.webp' alt='همراهی برای ساختن آینده‌ای روشن' height={228} width={332} data-sentry-element="Image" data-sentry-source-file="SignupLevels.tsx" />
            <Box maxWidth={346} sx={{
            transform: 'translate( +80px , -40px )'
          }} data-sentry-element="Box" data-sentry-source-file="SignupLevels.tsx">
              <Typography fontSize={{
              xs: 32,
              md: 40
            }} fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
                {text.title} <br />
                <strong className='highlight-tertiary'>
                  {' '}
                  {text.highlight}
                </strong>{' '}
                <br />
                {text.subtitle}
              </Typography>
            </Box>
          </Stack>
        </Grid>
        <Grid xs={12} md={7} data-sentry-element="Grid" data-sentry-source-file="SignupLevels.tsx">
          <Typography display={{
          xs: 'none',
          md: 'block'
        }} fontSize={24} fontWeight={800} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
            {text.levels}
          </Typography>
          <Stack direction='row' alignItems='stretch' data-sentry-element="Stack" data-sentry-source-file="SignupLevels.tsx">
            <Image src='/images/home/signup-levels.webp' alt='همراهی برای ساختن آینده‌ای روشن' width={76} height={302} style={{
            minHeight: '100%'
          }} data-sentry-element="Image" data-sentry-source-file="SignupLevels.tsx" />
            <Stack paddingY={3} justifyContent='center' gap={{
            xs: 3,
            md: 5
          }} sx={{
            pl: {
              xs: 3,
              md: 3
            },
            height: '100%'
          }} data-sentry-element="Stack" data-sentry-source-file="SignupLevels.tsx">
              <Stack data-sentry-element="Stack" data-sentry-source-file="SignupLevels.tsx">
                <Typography fontSize={{
                xs: 16,
                md: 18
              }} fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
                  {text.step1.title}
                </Typography>
                <Typography fontSize={{
                xs: 16,
                md: 18
              }} fontWeight={500} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
                  {text.step1.description}
                </Typography>
              </Stack>
              <Stack data-sentry-element="Stack" data-sentry-source-file="SignupLevels.tsx">
                <Typography fontSize={{
                xs: 16,
                md: 18
              }} fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
                  {text.step2.title}
                </Typography>
                <Typography fontSize={{
                xs: 16,
                md: 18
              }} fontWeight={500} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
                  {text.step2.description}
                </Typography>
              </Stack>
              <Stack data-sentry-element="Stack" data-sentry-source-file="SignupLevels.tsx">
                <Typography fontSize={{
                xs: 16,
                md: 18
              }} fontWeight={700} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
                  {text.step3.title}
                </Typography>
                <Typography fontSize={{
                xs: 16,
                md: 18
              }} fontWeight={500} data-sentry-element="Typography" data-sentry-source-file="SignupLevels.tsx">
                  {text.step3.description}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Section>;
};